module.exports = __webpack_public_path__ + "media/app/assets/classes/demon_hunter-e9cdbd5abb4006e11d0bb65c7907fe2e.jpg";